import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/api/client';

export type PlatformConnectStatus = {
  tenantId: string;
  name: string;
  slug: string;

  connectStatus: 'CONNECTED' | 'PENDING' | 'NOT_STARTED';
  stripeAccountId: string | null;
  chargesEnabled: boolean;
  payoutsEnabled: boolean;

  totalRevenue: number;
  totalPlatformFees: number;
  platformFeePercent: number | null;

  createdAt: string | null;
  lastPaymentAt: string | null;

  hasInvitePending: boolean;
};

export type ResendInviteResponse = {
  status: 'RESENT' | 'ALREADY_ACTIVATED';
  message: string;
  email?: string;
};

export function usePlatformConnect() {
  return useQuery({
    queryKey: ['platform-connect'],
    queryFn: () => apiClient<PlatformConnectStatus[]>('/platform/connect'),
  });
}

export function useResendInvite() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (tenantId: string) =>
      apiClient<ResendInviteResponse>(`/platform/connect/${tenantId}/resend-invite`, {
        method: 'POST',
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['platform-connect'] });
    },
  });
}
